import React, { Component } from "react";
import axios from "axios";
import "./informesClinicos.css";
import {
  API_INFORMES,
  API_CONSULTA_TERAPIA,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_PLAN,
  TIPO_INFORME_EVAL_INICIAL,
  TIPO_INFORME_EVAL_AVANCE,
  ramaDesdeTerapia,
  tienePlantillaInforme,
  etiquetaRama,
  pdfEvalInicialScript,
  RAMA_SENSORIAL,
} from "./api";
import InformeEvaluacionPlan from "./InformeEvaluacionPlan";
import InformeEvaluacionPlanSensorial from "./InformeEvaluacionPlanSensorial";
import InformeEvaluacionInicial from "./InformeEvaluacionInicial";
import InformeEvaluacionInicialSensorial from "./InformeEvaluacionInicialSensorial";
import InformeEvaluacionAvance from "./InformeEvaluacionAvance";
import InformeEvaluacionAvanceSensorial from "./InformeEvaluacionAvanceSensorial";
import AyudaMenuInformesModal from "./AyudaMenuInformesModal";
import AyudaAccionesInformesModal from "./AyudaAccionesInformesModal";

const TITULOS = {
  [TIPO_INFORME_EVAL_INICIAL]: "Evaluación Inicial",
  [TIPO_INFORME_EVAL_PLAN]: "Informe de Evaluación y Plan",
  [TIPO_INFORME_EVAL_AVANCE]: "Informe de avance",
};

class HubInformes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vista: "menu",
      tipoInformeActivo: TIPO_INFORME_EVAL_INICIAL,
      terapias: [],
      terapiaSel: null,
      informes: [],
      idInformeEdit: 0,
      sinInforme: [],
      sinInformeTipo: TIPO_INFORME_EVAL_PLAN,
      cargando: false,
      msg: "",
      errorCarga: "",
      datosCopiados: null,
      datosCopiadosKey: 0,
      verFechasPagadas: {},
      ramasEspecialista: [],
      ramaSeleccionada: "",
      reportesModalAbierto: false,
      reportesCargando: false,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
      pacienteActivoCedula: "",
      pacienteActivoNombre: "",
      desdeListaSinInforme: false,
      ayudaMenuAbierta: false,
      ayudaAccionesAbierta: false,
    };
  }

  cedulaPacienteActiva = () =>
    String(this.state.pacienteActivoCedula || this.props.cedulaPaciente || "").trim();

  nombrePacienteActivo = () => {
    const nombre = String(
      this.state.pacienteActivoNombre || this.props.nombrePaciente || ""
    ).trim();
    return nombre || this.cedulaPacienteActiva();
  };

  resolverTerapiaDesdeLista = (terapias, idasociarE, ramaSeleccionada) => {
    const lista = terapias || [];
    const idObj = Number(idasociarE || 0);
    if (idObj > 0) {
      const porId = lista.find((t) => {
        const ids = this.idsGrupoTerapia(t);
        return ids.indexOf(String(idObj)) >= 0;
      });
      if (porId) return porId;
    }
    if (ramaSeleccionada) {
      const porRama = lista.find((t) => this.ramaDeTerapia(t) === ramaSeleccionada);
      if (porRama) return porRama;
    }
    return lista.length === 1 ? lista[0] : null;
  };

  componentDidMount() {
    if (this.props.cedulaPaciente) {
      this.cargarTerapias();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.cedulaPaciente !== this.props.cedulaPaciente &&
      this.props.cedulaPaciente
    ) {
      this.setState({
        vista: "menu",
        ramaSeleccionada: "",
        ramasEspecialista: [],
        terapiaSel: null,
        pacienteActivoCedula: "",
        pacienteActivoNombre: "",
        desdeListaSinInforme: false,
      });
      this.cargarTerapias();
    }
  }

  ramaDeTerapia = (t) => t.ramaEspecialidad || ramaDesdeTerapia(t);

  idsGrupoTerapia = (t) => {
    if (!t) return [];
    if (Array.isArray(t.idasociarEGrupo) && t.idasociarEGrupo.length > 0) {
      return t.idasociarEGrupo.map(String);
    }
    return [String(t.idasociarE)];
  };

  claveListaTerapia = (t) =>
    t.claveGrupo || this.idsGrupoTerapia(t).join("-");

  tieneEvalInicialCreada = (t) =>
    !!t.yaTieneEvalInicial || Number(t.idInformeEvalInicial || 0) > 0;

  requisitosInformePlan = (terapias) => {
    const lista = terapias || [];
    const hayEvalInicial = lista.some((t) => this.tieneEvalInicialCreada(t));
    const hayCuatroCitas = lista.some((t) => Number(t.citasPagadas || 0) >= 4);
    const habilitado = lista.some((t) => !!t.habilitadoEvalPlan);
    return { hayEvalInicial, hayCuatroCitas, habilitado };
  };

  tieneEvalPlanCreada = (t) =>
    !!t.yaTieneEvalPlan || Number(t.idInformeEvalPlan || 0) > 0;

  requisitosInformeAvance = (terapias) => {
    const lista = terapias || [];
    const hayPlan = lista.some((t) => this.tieneEvalPlanCreada(t));
    const habilitado = lista.some((t) => !!t.habilitadoEvalAvance);
    const puedeCrear = lista.some((t) => !!t.puedeCrearAvance);
    return { hayPlan, habilitado, puedeCrear };
  };

  informePerteneceEstudio = (inf, terapiaSel) => {
    if (!inf || !terapiaSel) return false;
    const ids = this.idsGrupoTerapia(terapiaSel);
    if (ids.indexOf(String(inf.idasociarE)) >= 0) return true;
    if (
      (this.state.tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL ||
        this.state.tipoInformeActivo === TIPO_INFORME_EVAL_PLAN ||
        this.state.tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE) &&
      inf.cedulaEspecialista === (this.props.cedulaEspecialista || "") &&
      String(inf.tipoEvaluacion) === String(terapiaSel.tipoEvaluacion)
    ) {
      return true;
    }
    return false;
  };

  terapiasActivas = () => {
    const { terapias, ramaSeleccionada } = this.state;
    const lista = terapias || [];
    if (!ramaSeleccionada) return lista;
    return lista.filter((t) => this.ramaDeTerapia(t) === ramaSeleccionada);
  };

  ramasDesdeTerapias = (terapias) => {
    const vistas = {};
    const out = [];
    (terapias || []).forEach((t) => {
      const rama = this.ramaDeTerapia(t);
      if (!vistas[rama]) {
        vistas[rama] = true;
        out.push({ rama, etiqueta: etiquetaRama(rama) });
      }
    });
    return out;
  };

  onRamaChange = (e) => {
    this.setState({
      ramaSeleccionada: e.target.value,
      vista: "menu",
      terapiaSel: null,
      msg: "",
    });
  };

  postListarTerapias = (url, cedulaPaciente) => {
    const data = new FormData();
    data.append("boton", "listarTerapiasPaciente");
    data.append(
      "cedulaPaciente",
      cedulaPaciente || this.cedulaPacienteActiva()
    );
    data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
    return axios.post(url, data, { timeout: 45000 });
  };

  aplicarListaTerapias = (res, opciones = {}) => {
    const mantenerVista = !!opciones.mantenerVista;
    const terapias =
      res.data && Array.isArray(res.data.variable2) ? res.data.variable2 : [];
    let ramasEspecialista =
      res.data && Array.isArray(res.data.variable3) ? res.data.variable3 : [];
    if (ramasEspecialista.length === 0) {
      ramasEspecialista = this.ramasDesdeTerapias(terapias);
    }
    const ramaPreferida = opciones.ramaSeleccionada || this.state.ramaSeleccionada;
    const ramaSeleccionada =
      ramaPreferida ||
      (ramasEspecialista.length > 0
        ? ramasEspecialista[0].rama
        : terapias.length > 0
          ? this.ramaDeTerapia(terapias[0])
          : "");
    this.setState({
      cargando: false,
      terapias,
      ramasEspecialista,
      ramaSeleccionada,
      errorCarga: "",
      vista: mantenerVista ? this.state.vista : "menu",
    });
  };

  cargarTerapias = (opciones = {}) => {
    const ramaPreservar = opciones.ramaSeleccionada || this.state.ramaSeleccionada;
    if (!this.cedulaPacienteActiva()) {
      this.setState({
        cargando: false,
        errorCarga: "No hay cédula de paciente. Consulte el paciente primero.",
      });
      return;
    }
    this.setState({
      cargando: true,
      errorCarga: "",
      terapias: [],
      ramasEspecialista: [],
    });
    const aplicarOpts = {
      mantenerVista: !!opciones.mantenerVista,
      ramaSeleccionada: ramaPreservar,
    };
    this.postListarTerapias(API_INFORMES)
      .then((res) => {
        if (res.data && res.data.variable1 === false) {
          throw new Error(res.data.variable2 || "Error en informesClinicos.php");
        }
        this.aplicarListaTerapias(res, aplicarOpts);
      })
      .catch(() => {
        this.postListarTerapias(API_CONSULTA_TERAPIA)
          .then((res) => this.aplicarListaTerapias(res, aplicarOpts))
          .catch((err) => {
            const detalle =
              err.response && err.response.status
                ? " HTTP " + err.response.status
                : err.message || "sin conexión";
            this.setState({
              cargando: false,
              terapias: [],
              errorCarga:
                "No se pudo cargar las terapias (" +
                detalle +
                "). Suba informesClinicos.php o actualice consultaInformesTerapia.php en el servidor.",
            });
          });
      });
  };

  ramaActivaTerapia = (terapia = null) => {
    const t = terapia || this.state.terapiaSel;
    if (!t) return null;
    return t.ramaEspecialidad || ramaDesdeTerapia(t);
  };

  cargarInformes = (terapia = null) => {
    const rama = this.ramaActivaTerapia(terapia);
    if (!rama) return;
    const data = new FormData();
    data.append("boton", "listarPorPaciente");
    data.append("cedulaPaciente", this.cedulaPacienteActiva());
    data.append("tipoInforme", this.state.tipoInformeActivo);
    data.append("ramaEspecialidad", rama);
    data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ informes: res.data.variable2 || [] });
    });
  };

  irMenu = () => {
    const ramaActual = this.state.ramaSeleccionada;
    this.setState(
      {
        vista: "menu",
        terapiaSel: null,
        idInformeEdit: 0,
        msg: "",
        datosCopiados: null,
      },
      () =>
        this.cargarTerapias({
          mantenerVista: true,
          ramaSeleccionada: ramaActual,
        })
    );
  };

  volverDesdeFormulario = () => {
    if (this.state.desdeListaSinInforme) {
      this.setState(
        {
          vista: "sin_informe",
          datosCopiados: null,
          idInformeEdit: 0,
          terapiaSel: null,
          pacienteActivoCedula: "",
          pacienteActivoNombre: "",
          desdeListaSinInforme: false,
        },
        () => this.cargarSinInforme(TIPO_INFORME_EVAL_INICIAL)
      );
      return;
    }
    this.setState({ vista: "acciones", datosCopiados: null });
  };

  seleccionarPacienteDesdeLista = (row) => {
    if (this.state.cargando) return;
    if (this.state.sinInformeTipo !== TIPO_INFORME_EVAL_INICIAL) return;

    const cedula = row.cedulaPaciente;
    const nombre = row.nombrePaciente || cedula;
    const idObjetivo = Number(row.idasociarE || 0);
    const { ramaSeleccionada } = this.state;

    this.setState({
      cargando: true,
      msg: "",
      pacienteActivoCedula: cedula,
      pacienteActivoNombre: nombre,
    });

    const irAlMenuConTerapias = (res) => {
      const terapias =
        res.data && Array.isArray(res.data.variable2) ? res.data.variable2 : [];
      let ramasEspecialista =
        res.data && Array.isArray(res.data.variable3) ? res.data.variable3 : [];
      if (ramasEspecialista.length === 0) {
        ramasEspecialista = this.ramasDesdeTerapias(terapias);
      }
      const terapia = this.resolverTerapiaDesdeLista(
        terapias,
        idObjetivo,
        ramaSeleccionada
      );
      if (!terapia) {
        this.setState({
          cargando: false,
          vista: "sin_informe",
          msg:
            "No se encontró el estudio activo de este paciente para la especialidad seleccionada.",
        });
        return;
      }
      const rama = this.ramaDeTerapia(terapia);
      this.setState({
        cargando: false,
        terapias,
        ramasEspecialista,
        ramaSeleccionada: rama || ramaSeleccionada,
        terapiaSel: null,
        tipoInformeActivo: TIPO_INFORME_EVAL_INICIAL,
        vista: "menu",
        idInformeEdit: 0,
        informes: [],
        datosCopiados: null,
        errorCarga: "",
        desdeListaSinInforme: false,
        msg: "",
        pacienteActivoCedula: cedula,
        pacienteActivoNombre: nombre,
      });
    };

    this.postListarTerapias(API_INFORMES, cedula)
      .then((res) => {
        if (res.data && res.data.variable1 === false) {
          throw new Error(res.data.variable2 || "Error en informesClinicos.php");
        }
        irAlMenuConTerapias(res);
      })
      .catch(() => {
        this.postListarTerapias(API_CONSULTA_TERAPIA, cedula)
          .then(irAlMenuConTerapias)
          .catch(() => {
            this.setState({
              cargando: false,
              vista: "sin_informe",
              msg: "No se pudo cargar el estudio del paciente.",
            });
          });
      });
  };

  irAccionesTerapia = (t) => {
    this.setState({ terapiaSel: t, vista: "acciones", msg: "" }, () => this.cargarInformes(t));
  };

  abrirTipoInforme = (tipoInformeActivo) => {
    const activas = this.terapiasActivas();
    if (activas.length === 0) {
      this.setState({
        msg:
          "El paciente no tiene estudios activos de " +
          etiquetaRama(this.state.ramaSeleccionada) +
          " con usted.",
      });
      return;
    }
    if (tipoInformeActivo === TIPO_INFORME_EVAL_PLAN) {
      const req = this.requisitosInformePlan(activas);
      if (!req.hayEvalInicial) {
        this.setState({
          msg:
            "Debe crear primero la Evaluación Inicial de un estudio de " +
            etiquetaRama(this.state.ramaSeleccionada) +
            " antes del Informe de Evaluación y Plan.",
        });
        return;
      }
      if (!req.hayCuatroCitas) {
        this.setState({
          msg:
            "El Informe de Evaluación y Plan requiere 4 citas pagadas en el estudio (suma de todos los días).",
        });
        return;
      }
    }
    const irAccionesDirecto = (terapia) => {
      this.setState(
        {
          tipoInformeActivo,
          terapiaSel: terapia,
          vista: "acciones",
          msg: "",
        },
        () => this.cargarInformes(terapia)
      );
    };

    if (tipoInformeActivo === TIPO_INFORME_EVAL_PLAN) {
      const terapiaPlan =
        activas.find((t) => !!t.habilitadoEvalPlan) || activas[0];
      irAccionesDirecto(terapiaPlan);
      return;
    }

    if (tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE) {
      const reqAv = this.requisitosInformeAvance(activas);
      if (!reqAv.hayPlan) {
        this.setState({
          msg: "Debe crear primero el Informe de Evaluación y Plan antes del Informe de avance.",
        });
        return;
      }
      const terapiaAv =
        activas.find((t) => this.tieneEvalPlanCreada(t)) || activas[0];
      irAccionesDirecto(terapiaAv);
      return;
    }

    if (tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL && activas.length === 1) {
      irAccionesDirecto(activas[0]);
      return;
    }
    this.setState({ vista: "terapias", tipoInformeActivo, msg: "" });
  };

  abrirReportesEstudio = (t, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const ids = this.idsGrupoTerapia(t);
    const idPrincipal = t.idasociarE || ids[0];
    if (!idPrincipal) {
      this.setState({ reportesError: "No se identificó el estudio (idasociarE)." });
      return;
    }
    const data = new FormData();
    data.append("boton", "listarReportesCita");
    data.append("idasociarE", idPrincipal);
    if (ids.length > 1) {
      data.append("idasociarEGrupo", ids.join(","));
    }
    this.setState({
      reportesModalAbierto: true,
      reportesCargando: true,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
    });
    axios
      .post(API_INFORMES, data)
      .then((res) => {
        if (res.data && res.data.variable1) {
          this.setState({
            reportesCargando: false,
            reportesCita: Array.isArray(res.data.variable2) ? res.data.variable2 : [],
            reportesDuplicados: Number(res.data.variable3 || 0),
          });
          return;
        }
        this.setState({
          reportesCargando: false,
          reportesError: (res.data && res.data.variable2) || "No se pudo cargar los reportes.",
        });
      })
      .catch((err) => {
        this.setState({
          reportesCargando: false,
          reportesError: err.message || "No se pudo cargar los reportes.",
        });
      });
  };

  cerrarReportes = () => {
    this.setState({ reportesModalAbierto: false });
  };

  renderModalReportes = () => {
    const {
      reportesModalAbierto,
      reportesCargando,
      reportesError,
      reportesCita,
      reportesDuplicados,
    } = this.state;
    if (!reportesModalAbierto) return null;
    return (
      <div className="ic-modalOverlay" onClick={this.cerrarReportes}>
        <div className="ic-modalCard" onClick={(e) => e.stopPropagation()}>
          <div className="ic-modalHeader">
            <h4>Reportes de la cita</h4>
            <button type="button" className="boton" onClick={this.cerrarReportes}>
              Cerrar
            </button>
          </div>
          {reportesCargando && <p>Cargando reportes...</p>}
          {!reportesCargando && reportesError && (
            <div className="ic-msg">{reportesError}</div>
          )}
          {!reportesCargando && !reportesError && reportesCita.length === 0 && (
            <p>No hay reportes registrados para este estudio.</p>
          )}
          {!reportesCargando && reportesDuplicados > 0 && (
            <p className="ic-hint">
              Se ocultaron {reportesDuplicados} reporte(s) duplicado(s) en esta vista.
            </p>
          )}
          {!reportesCargando && reportesCita.length > 0 && (
            <div className="ic-modalList">
              {reportesCita.map((r, idx) => (
                <div key={`${r.idmensaje}-${idx}`} className="ic-modalItem">
                  <div>
                    <strong>Fecha cita:</strong> {r.fechaCita || "-"}{" "}
                    <span className="ic-hint">| Registro: {r.fechaMensaje || "-"}</span>
                  </div>
                  <div>
                    <strong>Mensaje:</strong> {r.mensaje || "(sin texto)"}
                  </div>
                  {r.ruta ? (
                    <div>
                      <strong>Adjunto:</strong> {r.ruta}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderResumenEstudio = (t, opciones = {}) => {
    if (!t) return null;
    const { claveFechas = "menu-estudio", soloEvalInicial = true, mostrarReportes = false } =
      opciones;
    const { verFechasPagadas } = this.state;
    const citasPag = Number(t.citasPagadas || 0);
    return (
      <div className="ic-resumenEstudio">
        <div className="ic-resumenEstudio-top">
          <div>
            <strong>{t.nombreEspecialidad}</strong>
            {t.ramaEspecialidad && (
              <span className="ic-ramaBadge"> — {etiquetaRama(t.ramaEspecialidad)}</span>
            )}
          </div>
          <div className="ic-resumenEstudio-topAcciones">
            {Array.isArray(t.fechasCitasPagadas) && t.fechasCitasPagadas.length > 0 && (
              <button
                type="button"
                className="boton"
                onClick={(e) => this.toggleFechasPagadas(claveFechas, e)}
              >
                {verFechasPagadas[claveFechas]
                  ? "Ocultar Terapias Pagadas"
                  : "Terapias Pagadas"}
              </button>
            )}
            {mostrarReportes && (
              <button
                type="button"
                className="boton ic-btnReportesMenu"
                onClick={(e) => this.abrirReportesEstudio(t, e)}
              >
                Reportes Diarios
              </button>
            )}
          </div>
        </div>
        <div className="ic-resumenEstudio-linea ic-resumenEstudio-lineaUnica">
          {Array.isArray(t.diasAtencion) && t.diasAtencion.length > 0 && (
            <span>Días: {t.diasAtencion.join(", ")}</span>
          )}
          <span>
            Inicio: {t.fechaInicio}
            {soloEvalInicial ? (
              <>
                {" "}
                | Citas pagadas: {citasPag} de 4
              </>
            ) : (
              <>
                {" "}
                | Citas pagadas: {t.citasPagadas} de 4
              </>
            )}
          </span>
        </div>
        {Array.isArray(t.fechasCitasPagadas) && t.fechasCitasPagadas.length > 0 && (
          <>
            {verFechasPagadas[claveFechas] && (
              <div className="ic-citasDetalle">
                {(t.fechasCitasPagadas || []).map((c, idx) => (
                  <div key={`${claveFechas}-pago-${idx}`}>
                    - {c.fecha}
                    {c.recibo ? ` (recibo ${c.recibo})` : ""}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  seleccionarTerapia = (t) => {
    this.setState({ terapiaSel: t, vista: "acciones" }, () => this.cargarInformes(t));
  };

  terapiaHabilitada = (t) => {
    if (this.state.tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL) {
      return true;
    }
    if (this.state.tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE) {
      return !!t.habilitadoEvalAvance;
    }
    return !!t.habilitadoEvalPlan;
  };

  toggleFechasPagadas = (idasociarE, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState((prev) => ({
      verFechasPagadas: {
        ...prev.verFechasPagadas,
        [idasociarE]: !prev.verFechasPagadas[idasociarE],
      },
    }));
  };

  abrirPdfEvalInicial = (t, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const idInforme = Number(t.idInformeEvalInicial || 0);
    if (!idInforme) {
      this.setState({ msg: "No se encontró la Evaluación Inicial para esta terapia." });
      return;
    }
    const rama = t.ramaEspecialidad || ramaDesdeTerapia(t);
    const script = pdfEvalInicialScript(rama);
    const url = `${API_INFORMES_PDF}${script}?idInforme=${encodeURIComponent(String(idInforme))}`;
    window.open(url, "_blank");
  };

  crearNuevo = () => {
    const t = this.state.terapiaSel;
    const esEvalInicial = this.state.tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL;
    const esEvalPlan = this.state.tipoInformeActivo === TIPO_INFORME_EVAL_PLAN;
    const esEvalAvance = this.state.tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE;
    const cedulaEsp = this.props.cedulaEspecialista || "";
    const idIni = Number(t.idInformeEvalInicial || 0);
    const ya = this.state.informes.find(
      (i) =>
        i.cedulaEspecialista === cedulaEsp && this.informePerteneceEstudio(i, t)
    );
    if (esEvalInicial && (idIni > 0 || ya)) {
      const abrir = idIni || (ya && ya.idInforme);
      this.setState({
        msg: "Ya existe su Evaluación Inicial para este estudio. Solo puede editarla.",
      });
      if (abrir) {
        this.editarInforme(abrir);
      }
      return;
    }
    if (esEvalPlan && ya) {
      this.setState({
        msg:
          "Ya existe su Informe de Evaluación y Plan para este estudio. Solo puede editarlo.",
      });
      return;
    }
    if (esEvalAvance) {
      const maxAv = Number(t.maxAvances || 4);
      const cantAv = Number(t.cantidadAvances || 0);
      if (cantAv >= maxAv) {
        this.setState({
          msg: `Ya alcanzó el máximo de ${maxAv} informes de avance para este estudio.`,
        });
        return;
      }
      if (!t.puedeCrearAvance) {
        const req = Number(t.citasRequeridasAvance || 16);
        const act = Number(t.citasDesdeReferenciaAvance || 0);
        const ref = t.fechaReferenciaAvance || "";
        this.setState({
          msg: `Desde ${ref}: ${act} citas pagadas de ${req} requeridas para el siguiente informe de avance.`,
        });
        return;
      }
    }
    if (!this.terapiaHabilitada(t)) {
      const msg =
        Number(t.idInformeEvalInicial || 0) <= 0
          ? "Para crear Informe de Evaluación y Plan primero debe crear la Evaluación Inicial de este estudio."
          : `Se requieren 4 citas pagadas para el Informe de Evaluación y Plan. Actual: ${t.citasPagadas} de 4.`;
      this.setState({ msg });
      return;
    }
    if (!esEvalInicial && !esEvalPlan && !esEvalAvance && ya) {
      if (
        window.confirm(
          "Ya tiene un informe suyo para esta terapia. ¿Desea editarlo?"
        )
      ) {
        this.setState({ idInformeEdit: ya.idInforme, vista: "form" });
      }
      return;
    }
    this.setState({
      idInformeEdit: 0,
      vista: "form",
      msg: "",
      datosCopiados: null,
      datosCopiadosKey: Date.now(),
    });
  };

  editarInforme = (id) => {
    this.setState({ idInformeEdit: id, vista: "form", datosCopiados: null });
  };

  utilizarDatos = (id) => {
    if (this.state.tipoInformeActivo === TIPO_INFORME_EVAL_PLAN) {
      return;
    }
    const data = new FormData();
    data.append("boton", "obtener");
    data.append("idInforme", id);
    data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data.variable1 && res.data.variable3) {
        const copia = res.data.variable3;
        const t = this.state.terapiaSel;
        if (t && copia.datosGenerales) {
          copia.datosGenerales.cedula = this.cedulaPacienteActiva();
          copia.datosGenerales.fechaInicioTerapia = t.fechaInicio;
        }
        this.setState({
          vista: "form",
          idInformeEdit: 0,
          msg: "Datos copiados. Complete y guarde como nuevo informe.",
          datosCopiados: copia,
          datosCopiadosKey: Date.now(),
        });
      }
    });
  };

  onGuardado = (newId) => {
    const tipo = this.state.tipoInformeActivo;
    this.setState({ idInformeEdit: newId, msg: "Informe guardado correctamente." });
    this.cargarInformes();
    if (tipo === TIPO_INFORME_EVAL_PLAN || tipo === TIPO_INFORME_EVAL_AVANCE) {
      this.postListarTerapias(API_INFORMES)
        .then((res) => {
          if (res.data && res.data.variable1 !== false) {
            const terapias = res.data.variable2 || [];
            this.setState((prev) => {
              const idSel = prev.terapiaSel && String(prev.terapiaSel.idasociarE);
              const actualizada =
                idSel &&
                terapias.find((t) => String(t.idasociarE) === idSel);
              return {
                terapias,
                terapiaSel: actualizada || prev.terapiaSel,
              };
            });
          }
        })
        .catch(() => {
          this.postListarTerapias(API_CONSULTA_TERAPIA)
            .then((res) => {
              if (res.data && res.data.variable1 !== false) {
                const terapias = res.data.variable2 || [];
                this.setState((prev) => {
                  const idSel = prev.terapiaSel && String(prev.terapiaSel.idasociarE);
                  const actualizada =
                    idSel &&
                    terapias.find((t) => String(t.idasociarE) === idSel);
                  return { terapias, terapiaSel: actualizada || prev.terapiaSel };
                });
              }
            })
            .catch(() => {});
        });
    }
  };

  eliminarInforme = (idInforme) => {
    const cedulaEsp = this.props.cedulaEspecialista || "";
    if (!cedulaEsp) {
      alert("No se identificó al especialista en sesión.");
      return;
    }
    if (
      !window.confirm(
        "¿Eliminar este informe? Esta acción no se puede deshacer."
      )
    ) {
      return;
    }
    const data = new FormData();
    data.append("boton", "eliminar");
    data.append("idInforme", idInforme);
    data.append("cedulaEspecialista", cedulaEsp);
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data && res.data.variable1) {
        const volverLista =
          this.state.vista === "form" &&
          Number(this.state.idInformeEdit) === Number(idInforme);
        this.setState({
          vista: volverLista ? "acciones" : this.state.vista,
          idInformeEdit: volverLista ? 0 : this.state.idInformeEdit,
          msg: res.data.variable2 || "Informe eliminado.",
        });
        this.cargarInformes();
      } else {
        alert(res.data.variable2 || "No se pudo eliminar el informe.");
      }
    });
  };

  cargarSinInforme = (tipo) => {
    const data = new FormData();
    data.append("boton", "pacientesSinInforme");
    data.append("sede", this.props.sede || "");
    data.append("tipoInforme", tipo);
    data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
    data.append("ramaEspecialidad", this.state.ramaSeleccionada || "");
    this.setState({ cargando: true, vista: "sin_informe", sinInformeTipo: tipo, msg: "" });
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({
        cargando: false,
        sinInforme: res.data.variable2 || [],
      });
    });
  };

  cerrarAyudaMenu = () => {
    this.setState({ ayudaMenuAbierta: false });
  };

  abrirAyudaMenu = () => {
    this.setState({ ayudaMenuAbierta: true });
  };

  cerrarAyudaAcciones = () => {
    this.setState({ ayudaAccionesAbierta: false });
  };

  abrirAyudaAcciones = () => {
    this.setState({ ayudaAccionesAbierta: true });
  };

  renderMenu() {
    const { terapias, msg, ramasEspecialista, ramaSeleccionada } = this.state;
    const activas = this.terapiasActivas();
    const hayCoincidenciaEspecialidad = activas.length > 0;
    const reqPlan = this.requisitosInformePlan(activas);
    const hayEvalInicialParaPlan = reqPlan.habilitado;
    const reqAvance = this.requisitosInformeAvance(activas);
    const hayPlanParaAvance = reqAvance.habilitado;
    const estudioMenu = activas.length > 0 ? activas[0] : null;
    let etiquetaPlanDeshabilitado = "";
    if (!hayEvalInicialParaPlan) {
      if (!reqPlan.hayEvalInicial) {
        etiquetaPlanDeshabilitado = " (requiere Evaluación Inicial creada)";
      } else if (!reqPlan.hayCuatroCitas) {
        etiquetaPlanDeshabilitado = " (requiere 4 citas pagadas)";
      }
    }
    let etiquetaAvanceMenu = "";
    if (!reqAvance.hayPlan) {
      etiquetaAvanceMenu = " (requiere Informe de Evaluación y Plan)";
    } else if (estudioMenu) {
      const cantAv = Number(estudioMenu.cantidadAvances || 0);
      const maxAv = Number(estudioMenu.maxAvances || 4);
      etiquetaAvanceMenu = ` (${cantAv} de ${maxAv})`;
    }
    const variasRamas = ramasEspecialista.length > 1;
    const sinEstudiosEnRama =
      variasRamas &&
      ramaSeleccionada &&
      activas.length === 0 &&
      (terapias || []).length > 0;
    const sinEstudiosGlobal =
      (terapias || []).length === 0 && !this.state.cargando && !this.state.errorCarga;
    return (
      <div className="ic-menu">
        <div className="ic-menuHeader">
          <h3>Tipos de Informe y Recomendaciones</h3>
          <button
            type="button"
            className="ic-link-ayuda"
            onClick={this.abrirAyudaMenu}
          >
            Ayuda
          </button>
        </div>
        {sinEstudiosEnRama && (
          <div className="ic-msg-error-top">
            El paciente no tiene estudios activos de{" "}
            <strong>{etiquetaRama(ramaSeleccionada)}</strong> con usted.
          </div>
        )}
        {sinEstudiosGlobal && !variasRamas && (
          <div className="ic-msg-error-top">
            La especialidad del paciente no coincide con la del especialista.
          </div>
        )}
        <p>
          Paciente:{" "}
          <strong>{this.nombrePacienteActivo()}</strong>
        </p>
        {variasRamas && (
          <p className="ic-selectRamaWrap">
            <label htmlFor="ic-ramaSel">
              Tipo de estudio:{" "}
              <select
                id="ic-ramaSel"
                className="ic-selectRama"
                value={ramaSeleccionada}
                onChange={this.onRamaChange}
              >
                {ramasEspecialista.map((r) => (
                  <option key={r.rama} value={r.rama}>
                    {r.etiqueta || etiquetaRama(r.rama)}
                  </option>
                ))}
              </select>
            </label>
          </p>
        )}
        <div className="ic-menuBloqueEvalInicial">
          {hayCoincidenciaEspecialidad && estudioMenu && (
            <div className="ic-menuResumenWrap">
              {this.renderResumenEstudio(estudioMenu, {
                claveFechas: "menu-estudio-inicial",
                soloEvalInicial: true,
                mostrarReportes: true,
              })}
            </div>
          )}
          <button
            type="button"
            className={`ic-menuItem ${!hayCoincidenciaEspecialidad ? "ic-off" : ""}`}
            onClick={() => this.abrirTipoInforme(TIPO_INFORME_EVAL_INICIAL)}
            disabled={!hayCoincidenciaEspecialidad}
          >
            1. Evaluación Inicial
          </button>
        </div>
        <button
          type="button"
          className={`ic-menuItem ${!hayEvalInicialParaPlan ? "ic-off" : ""}`}
          onClick={() => this.abrirTipoInforme(TIPO_INFORME_EVAL_PLAN)}
          disabled={!hayEvalInicialParaPlan}
        >
          2. Informe de Evaluación y Plan
          {etiquetaPlanDeshabilitado}
        </button>
        {msg && <div className="ic-msg">{msg}</div>}
        <button
          type="button"
          className={`ic-menuItem ${
            !hayCoincidenciaEspecialidad || !hayPlanParaAvance ? "ic-off" : ""
          }`}
          onClick={() => this.abrirTipoInforme(TIPO_INFORME_EVAL_AVANCE)}
          disabled={!hayCoincidenciaEspecialidad || !hayPlanParaAvance}
        >
          3. Informe de avance
          {etiquetaAvanceMenu}
        </button>
        <button type="button" className="ic-menuItem ic-off" disabled>
          4. Recomendaciones para el hogar (próximamente)
        </button>
        <button type="button" className="ic-menuItem ic-off" disabled>
          5. Recomendaciones para el colegio (próximamente)
        </button>
        <button type="button" className="ic-menuItem ic-off" disabled>
          6. Informe de alta (próximamente)
        </button>
        <div className="ic-actions" style={{ marginTop: 16 }}>
          <button
            type="button"
            className="boton"
            onClick={() => this.cargarSinInforme(TIPO_INFORME_EVAL_INICIAL)}
          >
            Pacientes sin Evaluación Inicial
          </button>
          <button
            type="button"
            className="boton"
            style={{ marginTop: 8 }}
            onClick={() => this.cargarSinInforme(TIPO_INFORME_EVAL_PLAN)}
          >
            Pacientes sin Informe Evaluación y Plan
          </button>
        </div>
      </div>
    );
  }

  renderTerapias() {
    const { cargando, errorCarga, tipoInformeActivo, verFechasPagadas } = this.state;
    const terapias = this.terapiasActivas();
    const esEvalInicial = tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL;
    const etiquetaEstado = (t) => {
      if (esEvalInicial) {
        return t.yaTieneEvalInicial ? "(informe ya creado)" : "(disponible)";
      }
      if (Number(t.idInformeEvalInicial || 0) <= 0) {
        return "(pendiente Evaluación Inicial)";
      }
      if ((t.citasPagadas || 0) < 4) {
        return `(pendiente 4 citas pagadas: ${t.citasPagadas} de 4)`;
      }
      if (!this.terapiaHabilitada(t)) {
        return "(pendiente requisitos)";
      }
      return (
        <>
          (
          <button
            type="button"
            className="ic-link-inline"
            onClick={(e) => this.abrirPdfEvalInicial(t, e)}
            title="Ver PDF de Evaluación Inicial"
          >
            habilitado por Evaluación Inicial creada
          </button>
          )
        </>
      );
    };
    return (
      <div className="ic-panel ic-panel-scrollable">
        <div className="ic-panel-top-sticky">
          <h3>{TITULOS[tipoInformeActivo]} — seleccione terapia</h3>
          <p className="ic-hint">
            {esEvalInicial
              ? "Pulse el estudio y luego «Crear nuevo informe» para abrir el formulario."
              : "Después de elegir la terapia, pulse «Crear nuevo informe» para ver el formulario."}
          </p>
          {cargando && <p>Cargando terapias del paciente...</p>}
          {errorCarga && <div className="ic-msg">{errorCarga}</div>}
        </div>
        <div className="ic-panel-scroll-body">
          {terapias.length === 0 && !cargando && !errorCarga && (
            <p>No hay terapias activas para este paciente.</p>
          )}
          {terapias.map((t) => {
            const claveLista = this.claveListaTerapia(t);
            return (
            <div
              key={claveLista}
              className="ic-terapiaRow"
              onClick={() => this.seleccionarTerapia(t)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && this.seleccionarTerapia(t)}
            >
              <strong>{t.nombreEspecialidad}</strong>
              {t.ramaEspecialidad && (
                <span className="ic-ramaBadge"> — {etiquetaRama(t.ramaEspecialidad)}</span>
              )}
              {esEvalInicial ? (
                <p className="ic-hint" style={{ margin: "8px 0 0" }}>
                  Pulse para continuar con el informe.
                </p>
              ) : (
                <>
                  <br />
                  {Array.isArray(t.diasAtencion) && t.diasAtencion.length > 0 && (
                    <>
                      Días: {t.diasAtencion.join(", ")}
                      <br />
                    </>
                  )}
                  Inicio: {t.fechaInicio} | Citas pagadas: {t.citasPagadas} de 4{" "}
                  {etiquetaEstado(t)}
                  {(t.ramaEspecialidad || ramaDesdeTerapia(t)) &&
                    !tienePlantillaInforme(t.ramaEspecialidad || ramaDesdeTerapia(t)) && (
                    <>
                      <br />
                      <em className="ic-hint">
                        Plantilla en desarrollo para esta especialidad
                      </em>
                    </>
                  )}
                  {Array.isArray(t.fechasCitasPagadas) && t.fechasCitasPagadas.length > 0 && (
                    <>
                      <br />
                      <button
                        type="button"
                        className="boton"
                        onClick={(e) => this.toggleFechasPagadas(claveLista, e)}
                      >
                        {verFechasPagadas[claveLista]
                          ? "Ocultar Terapias Pagadas"
                          : "Terapias Pagadas"}
                      </button>
                    </>
                  )}
                  {verFechasPagadas[claveLista] && (
                    <div className="ic-citasDetalle">
                      {(t.fechasCitasPagadas || []).map((c, idx) => (
                        <div key={`${claveLista}-pago-${idx}`}>
                          - {c.fecha}
                          {c.recibo ? ` (recibo ${c.recibo})` : ""}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
              {esEvalInicial && !tienePlantillaInforme(t.ramaEspecialidad || ramaDesdeTerapia(t)) && (
                  <>
                    <br />
                    <em className="ic-hint">
                      Plantilla en desarrollo para esta especialidad
                    </em>
                  </>
                )}
            </div>
          );
          })}
        </div>
        <div className="ic-panel-bottom-sticky">
          <button type="button" className="boton" onClick={this.irMenu}>
            Volver al menú
          </button>
        </div>
      </div>
    );
  }

  renderListaInforme = (inf, indiceAvance) => (
    <div key={inf.idInforme} className="ic-listaInforme">
      <span>
        {this.state.tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE && indiceAvance
          ? `Avance ${indiceAvance} — `
          : ""}
        {inf.fechaInforme}
        {this.state.tipoInformeActivo === TIPO_INFORME_EVAL_PLAN &&
        inf.formato &&
        inf.formato !== "SENSORIAL"
          ? ` — ${inf.formato}`
          : ""}{" "}
        — mod. {inf.fechaModificacion}
      </span>
      <div className="ic-listaInforme-actions">
        <button type="button" className="boton" onClick={() => this.editarInforme(inf.idInforme)}>
          Editar
        </button>
        <button
          type="button"
          className="boton ic-btn-danger"
          onClick={() => this.eliminarInforme(inf.idInforme)}
        >
          Eliminar
        </button>
      </div>
    </div>
  );

  renderAcciones() {
    const { terapiaSel, informes, msg, tipoInformeActivo } = this.state;
    const cedulaEsp = this.props.cedulaEspecialista || "";
    const nombrePaciente = this.nombrePacienteActivo();
    const propios = informes.filter(
      (i) => i.cedulaEspecialista === cedulaEsp && this.informePerteneceEstudio(i, terapiaSel)
    );
    const existeEvalInicialEnTerapia = informes.some((i) =>
      this.informePerteneceEstudio(i, terapiaSel)
    );
    const bloquearCrearEvalInicial =
      tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL &&
      (!!terapiaSel.yaTieneEvalInicial ||
        Number(terapiaSel.idInformeEvalInicial || 0) > 0 ||
        propios.length > 0 ||
        existeEvalInicialEnTerapia);
    const bloquearCrearEvalPlan =
      tipoInformeActivo === TIPO_INFORME_EVAL_PLAN && propios.length > 0;
    const esEvalAvance = tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE;
    const bloquearCrearAvance =
      esEvalAvance &&
      (!terapiaSel.puedeCrearAvance ||
        Number(terapiaSel.cantidadAvances || 0) >= Number(terapiaSel.maxAvances || 4));
    const bloquearCrear =
      bloquearCrearEvalInicial || bloquearCrearEvalPlan || bloquearCrearAvance;
    const etiquetaCrearNuevo =
      tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL
        ? "Crear Evaluación Inicial"
        : tipoInformeActivo === TIPO_INFORME_EVAL_PLAN
          ? "Crear Informe de Evaluación y Plan"
          : tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE
            ? "Crear Informe de avance"
            : "Crear nuevo informe";

    return (
      <div className="ic-panel">
        <div className="ic-panelHeader">
          <h3>{TITULOS[tipoInformeActivo]}</h3>
          <button
            type="button"
            className="ic-link-ayuda"
            onClick={this.abrirAyudaAcciones}
          >
            Ayuda
          </button>
        </div>
        <p>
          Paciente: <strong>{nombrePaciente}</strong>
        </p>
        <p>
          <strong>{terapiaSel.nombreEspecialidad}</strong>
          {terapiaSel.ramaEspecialidad && (
            <span> ({etiquetaRama(terapiaSel.ramaEspecialidad)})</span>
          )}{" "}
          — Inicio {terapiaSel.fechaInicio}
          {Array.isArray(terapiaSel.diasAtencion) && terapiaSel.diasAtencion.length > 0 && (
            <span> — Días: {terapiaSel.diasAtencion.join(", ")}</span>
          )}
        </p>
        {bloquearCrearEvalInicial && (
          <div className="ic-msg">
            Ya existe una Evaluación Inicial para esta terapia. Puede editarla en la lista.
          </div>
        )}
        {bloquearCrearEvalPlan && (
          <div className="ic-msg">
            Ya existe un Informe de Evaluación y Plan para esta terapia. Puede editarlo en
            la lista.
          </div>
        )}
        {esEvalAvance && bloquearCrearAvance && (terapiaSel.cantidadAvances || 0) < (terapiaSel.maxAvances || 4) && (
          <div className="ic-msg">
            Para crear el siguiente informe de avance, desde{" "}
            {terapiaSel.fechaReferenciaAvance || "la fecha de referencia"}:{" "}
            <strong>
              {terapiaSel.citasDesdeReferenciaAvance || 0} citas pagadas de{" "}
              {terapiaSel.citasRequeridasAvance || 16} requeridas
            </strong>
            .
          </div>
        )}
        {esEvalAvance && (terapiaSel.cantidadAvances || 0) >= (terapiaSel.maxAvances || 4) && (
          <div className="ic-msg">
            Máximo de {terapiaSel.maxAvances || 4} informes de avance alcanzado. Puede
            editar los existentes en la lista.
          </div>
        )}
        {esEvalAvance && (
          <p className="ic-hint">
            Informes de avance: {terapiaSel.cantidadAvances || 0} de{" "}
            {terapiaSel.maxAvances || 4}
          </p>
        )}
        {msg && <div className="ic-msg">{msg}</div>}
        <div className="ic-actions">
          <button
            type="button"
            className={bloquearCrear ? "botonOf" : "boton"}
            onClick={bloquearCrear ? undefined : this.crearNuevo}
            disabled={bloquearCrear}
            title={
              bloquearCrearEvalInicial
                ? "Ya existe una Evaluación Inicial para esta terapia."
                : bloquearCrearEvalPlan
                  ? "Ya existe un Informe de Evaluación y Plan para esta terapia."
                  : bloquearCrearAvance
                    ? "Aún no cumple las citas pagadas para el siguiente avance."
                    : ""
            }
          >
            {etiquetaCrearNuevo}
          </button>
          <button type="button" className="boton" onClick={this.irMenu}>
            Menú principal
          </button>
        </div>

        {propios.length > 0 && (
          <>
            {propios.map((inf, idx) =>
              this.renderListaInforme(
                inf,
                esEvalAvance ? idx + 1 : null
              )
            )}
          </>
        )}

        {this.state.tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL && informes.length > 0 && (
          <>
            <h4>Informes del paciente (todos los especialistas)</h4>
            {informes.map((inf) => (
              <div key={inf.idInforme} className="ic-listaInforme">
                <span>
                  {inf.nombreEspecialista} — {inf.nombreEspecialidad} — {inf.fechaInforme}
                </span>
                {inf.cedulaEspecialista !== cedulaEsp && (
                  <button
                    type="button"
                    className="boton"
                    onClick={() => this.utilizarDatos(inf.idInforme)}
                  >
                    Utilizar datos
                  </button>
                )}
                {inf.cedulaEspecialista === cedulaEsp &&
                  String(inf.idasociarE) !== String(terapiaSel.idasociarE) && (
                    <div className="ic-listaInforme-actions">
                      <button
                        type="button"
                        className="boton"
                        onClick={() => this.editarInforme(inf.idInforme)}
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        className="boton ic-btn-danger"
                        onClick={() => this.eliminarInforme(inf.idInforme)}
                      >
                        Eliminar
                      </button>
                    </div>
                  )}
              </div>
            ))}
          </>
        )}

        {propios.length === 0 && informes.length === 0 && (
          <p>No hay informes guardados aún para este paciente.</p>
        )}
      </div>
    );
  }

  renderSinInforme() {
    const { sinInforme, cargando, sinInformeTipo, ramaSeleccionada, msg } = this.state;
    const tituloBase =
      sinInformeTipo === TIPO_INFORME_EVAL_INICIAL
        ? "Pacientes elegibles sin Evaluación Inicial"
        : "Pacientes elegibles sin Informe de Evaluación y Plan";
    const titulo = ramaSeleccionada
      ? `${tituloBase} — ${etiquetaRama(ramaSeleccionada)}`
      : tituloBase;
    const clicEvalInicial = sinInformeTipo === TIPO_INFORME_EVAL_INICIAL;

    return (
      <div className="ic-panel">
        <h3>{titulo}</h3>
        {clicEvalInicial && sinInforme.length > 0 && !cargando && (
          <p className="ic-hint">
            Pulse una fila para cargar al paciente en el menú de informes.
          </p>
        )}
        {msg && <div className="ic-msg">{msg}</div>}
        {cargando && <p>Cargando...</p>}
        {sinInforme.length === 0 && !cargando && (
          <p>No hay pacientes pendientes con las reglas actuales.</p>
        )}
        {sinInforme.length > 0 && (
          <div>
            <div className="ic-tablaWrap">
              <table className="ic-tablaSin">
                <thead>
                  <tr>
                    <th>Cédula</th>
                    <th>Nombre</th>
                    <th>Especialidad</th>
                    <th>Inicio</th>
                    <th>Citas pag.</th>
                  </tr>
                </thead>
                <tbody>
                  {sinInforme.map((r, i) => (
                    <tr
                      key={`${r.cedulaPaciente}-${r.idasociarE || i}`}
                      className={clicEvalInicial ? "ic-sinInformeRowClick" : ""}
                      onClick={
                        clicEvalInicial
                          ? () => this.seleccionarPacienteDesdeLista(r)
                          : undefined
                      }
                      role={clicEvalInicial ? "button" : undefined}
                      tabIndex={clicEvalInicial ? 0 : undefined}
                      onKeyDown={
                        clicEvalInicial
                          ? (e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                this.seleccionarPacienteDesdeLista(r);
                              }
                            }
                          : undefined
                      }
                    >
                      <td>{r.cedulaPaciente}</td>
                      <td>{r.nombrePaciente}</td>
                      <td>{r.especialidad}</td>
                      <td>{r.fechaInicio}</td>
                      <td>{r.citasPagadas}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="ic-sinInformeCards">
              {sinInforme.map((r, i) => (
                <div
                  key={`card-${r.cedulaPaciente}-${r.idasociarE || i}`}
                  className={
                    clicEvalInicial
                      ? "ic-sinInformeCard ic-sinInformeCardClick"
                      : "ic-sinInformeCard"
                  }
                  onClick={
                    clicEvalInicial
                      ? () => this.seleccionarPacienteDesdeLista(r)
                      : undefined
                  }
                  role={clicEvalInicial ? "button" : undefined}
                  tabIndex={clicEvalInicial ? 0 : undefined}
                  onKeyDown={
                    clicEvalInicial
                      ? (e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.seleccionarPacienteDesdeLista(r);
                          }
                        }
                      : undefined
                  }
                >
                  <p>
                    <strong>Cédula:</strong> {r.cedulaPaciente}
                  </p>
                  <p>
                    <strong>Nombre:</strong> {r.nombrePaciente}
                  </p>
                  <p>
                    <strong>Especialidad:</strong> {r.especialidad}
                  </p>
                  <p>
                    <strong>Inicio:</strong> {r.fechaInicio}
                  </p>
                  <p>
                    <strong>Citas pagadas:</strong> {r.citasPagadas}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        <button type="button" className="boton" onClick={this.irMenu}>
          Volver al menú
        </button>
      </div>
    );
  }

  renderFormulario() {
    const {
      terapiaSel,
      idInformeEdit,
      tipoInformeActivo,
      datosCopiados,
      datosCopiadosKey,
      informes,
    } = this.state;
    const { cedulaEspecialista, sede } = this.props;
    const cedulaPaciente = this.cedulaPacienteActiva();
    const rama = terapiaSel.ramaEspecialidad || ramaDesdeTerapia(terapiaSel);

    if (!tienePlantillaInforme(rama)) {
      return (
        <div className="ic-panel">
          <h3>{TITULOS[tipoInformeActivo]} — {etiquetaRama(rama)}</h3>
          <p className="ic-msg">
            La plantilla de informes para <strong>{etiquetaRama(rama)}</strong> está en
            desarrollo.
          </p>
          <button
            type="button"
            className="boton"
            onClick={() => this.setState({ vista: "acciones" })}
          >
            Volver
          </button>
        </div>
      );
    }

    const common = {
      cedulaPaciente,
      nombrePaciente: this.nombrePacienteActivo(),
      cedulaEspecialista,
      tipoEvaluacion: terapiaSel.tipoEvaluacion,
      idasociarE: terapiaSel.idasociarE,
      idasociarEGrupo: terapiaSel.idasociarEGrupo || [terapiaSel.idasociarE],
      ramaEspecialidad: rama,
      sede,
      idInforme: idInformeEdit,
      initialDatos: idInformeEdit ? null : datosCopiados,
      onGuardado: this.onGuardado,
      onEliminar: this.eliminarInforme,
      onVolver: this.volverDesdeFormulario,
    };

    if (tipoInformeActivo === TIPO_INFORME_EVAL_INICIAL) {
      if (rama === RAMA_SENSORIAL) {
        return (
          <InformeEvaluacionInicialSensorial
            key={`inis-${idInformeEdit}-${datosCopiadosKey}`}
            {...common}
          />
        );
      }
      return (
        <InformeEvaluacionInicial
          key={`ini-${idInformeEdit}-${datosCopiadosKey}`}
          {...common}
        />
      );
    }

    if (tipoInformeActivo === TIPO_INFORME_EVAL_AVANCE) {
      const numeroAvance =
        idInformeEdit > 0
          ? (informes || [])
              .filter(
                (i) =>
                  i.cedulaEspecialista === cedulaEspecialista &&
                  this.informePerteneceEstudio(i, terapiaSel)
              )
              .sort((a, b) => String(a.fechaInforme).localeCompare(String(b.fechaInforme)))
              .findIndex((i) => Number(i.idInforme) === Number(idInformeEdit)) + 1
          : (terapiaSel.cantidadAvances || 0) + 1;
      if (rama === RAMA_SENSORIAL) {
        return (
          <InformeEvaluacionAvanceSensorial
            key={`avs-${idInformeEdit}-${datosCopiadosKey}`}
            {...common}
            nombreEspecialista={terapiaSel.nombreEspecialista}
            numeroAvance={numeroAvance > 0 ? numeroAvance : ""}
          />
        );
      }
      return (
        <InformeEvaluacionAvance
          key={`av-${idInformeEdit}-${datosCopiadosKey}`}
          {...common}
          nombreEspecialista={terapiaSel.nombreEspecialista}
          diasAtencion={terapiaSel.diasAtencion}
          numeroAvance={numeroAvance > 0 ? numeroAvance : ""}
        />
      );
    }

    if (rama === RAMA_SENSORIAL) {
      return (
        <InformeEvaluacionPlanSensorial
          key={`plans-${idInformeEdit}-${datosCopiadosKey}`}
          {...common}
          nombreEspecialista={terapiaSel.nombreEspecialista}
        />
      );
    }

    return (
      <InformeEvaluacionPlan
        key={`plan-${idInformeEdit}-${datosCopiadosKey}`}
        {...common}
      />
    );
  }

  render() {
    const { vista, terapiaSel } = this.state;
    const { onClose } = this.props;

    return (
      <div className="flotadorInformesClinicos">
        <div className="flotadorInformesClinicosHeader">
          <h2>REPORTES INFORMES</h2>
          <button type="button" className="boton" onClick={onClose}>
            Cerrar
          </button>
        </div>
        <div className="flotadorInformesClinicosBody">
          {vista === "menu" && this.renderMenu()}
          {vista === "terapias" && this.renderTerapias()}
          {vista === "acciones" && this.renderAcciones()}
          {vista === "sin_informe" && this.renderSinInforme()}
          {vista === "form" && terapiaSel && this.renderFormulario()}
        </div>
        {this.renderModalReportes()}
        <AyudaMenuInformesModal
          abierto={this.state.ayudaMenuAbierta}
          onCerrar={this.cerrarAyudaMenu}
        />
        <AyudaAccionesInformesModal
          abierto={this.state.ayudaAccionesAbierta}
          tipoInforme={this.state.tipoInformeActivo}
          onCerrar={this.cerrarAyudaAcciones}
        />
      </div>
    );
  }
}

export default HubInformes;
